import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const SVGComponent = ({ color = '#F2F7FF', ...props }: { color?: string }) => (
  <Svg width={48} height={48} viewBox="0 0 48 48" fill="none" {...props}>
    <G clipPath="url(#clip0_1051_8317)">
      <Rect width={48} height={48} rx={8} fill="#F2F7FF" />
      <Path
        d="M37.4426 30.1105C37.4426 35.2646 33.2644 39.4428 28.1102 39.4428C25.3932 39.4428 22.9473 38.2818 21.242 36.4287C20.794 35.9423 20.3975 35.4078 20.06 34.8346C19.2452 33.4488 18.7778 31.8341 18.7778 30.1105C18.7778 24.9563 22.9561 20.7781 28.1102 20.7781C29.8342 20.7781 31.4489 21.2455 32.8343 22.0606C33.4076 22.3977 33.9416 22.7943 34.4281 23.2426C36.2812 24.9472 37.4426 27.3934 37.4426 30.1105Z"
        fill="url(#paint0_radial_1051_8317)"
      />
      <Path
        d="M28.0942 15.109C28.022 15.1128 27.9513 15.1314 27.8872 15.1648C27.8872 15.1648 21.9498 18.1264 14.5457 19.1136C14.297 19.148 14.1123 19.3615 14.1141 19.6126V30.1076C14.1141 36.537 17.6341 40.3507 21.1046 42.4716C24.5752 44.5925 28.0385 45.1032 28.0385 45.1032C28.0877 45.1107 28.1377 45.1107 28.1869 45.1032C28.1869 45.1032 31.6503 44.5925 35.1208 42.4716C38.5913 40.3507 42.1113 36.537 42.1113 30.1076V19.6126C42.1134 19.3615 41.9285 19.1479 41.6797 19.1136C34.2757 18.1264 28.3383 15.1648 28.3383 15.1648C28.263 15.1259 28.179 15.1066 28.0942 15.109ZM28.1127 21.1104C33.0768 21.1104 37.1098 25.1434 37.1098 30.1075C37.1098 35.0716 33.0768 39.1096 28.1127 39.1096C23.1486 39.1096 19.1156 35.0716 19.1156 30.1075C19.1156 25.1434 23.1486 21.1104 28.1127 21.1104Z"
        fill="url(#paint1_radial_1051_8317)"
      />
      <Path
        d="M26.244 25.5748V27.9108H23.9125C23.6547 27.9099 23.445 28.1179 23.444 28.3757V31.1766C23.4449 31.4343 23.6547 31.6424 23.9125 31.6414H26.244V33.9775C26.2449 34.2355 26.4553 34.4438 26.7134 34.4423H29.5097C29.7674 34.4432 29.9772 34.2352 29.9782 33.9775V31.6414H32.3106C32.5683 31.6423 32.7781 31.4343 32.7791 31.1766V28.3757C32.7782 28.1179 32.5683 27.9098 32.3106 27.9108H29.9782V25.5748C29.9773 25.317 29.7674 25.1089 29.5097 25.1099H26.6892C26.426 25.1334 26.2438 25.3345 26.244 25.5748Z"
        fill="white"
      />
      <Path
        d="M42.9783 42.3742H42.9776L33.1147 50.2856C32.3042 50.9359 31.2642 51.232 30.2321 51.1061L16.9392 49.4883L13.3973 50.7985C11.4947 48.8417 12.2766 42.928 12.2766 42.928L13.1201 42.3149C13.0469 41.1878 13.5784 40.0687 14.565 39.4283C14.6738 39.357 14.7879 39.2924 14.908 39.2337L20.6081 36.45L23.5395 35.0183C23.6992 34.9404 23.862 34.8791 24.0276 34.8343C25.253 34.4986 26.5832 35.0374 27.2103 36.1928C27.9219 37.5046 27.4734 39.1441 26.1934 39.9111L21.4549 42.751L29.4289 44.1399C30.3885 44.3067 31.3757 44.1049 32.1935 43.574L40.124 38.426C41.1878 37.7349 42.6031 37.9749 43.3807 38.978C43.5818 39.2379 43.723 39.5261 43.8053 39.8255C44.0546 40.7354 43.7598 41.7471 42.9783 42.3742Z"
        fill="url(#paint2_radial_1051_8317)"
      />
      <Rect
        x={6.13354}
        y={43.0489}
        width={5.57035}
        height={10.6923}
        rx={2.78518}
        transform="rotate(-17.3376 6.13354 43.0489)"
        fill="url(#paint3_radial_1051_8317)"
      />
    </G>
    <Defs>
      <RadialGradient
        id="paint0_radial_1051_8317"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37 22) rotate(137.911) scale(20.8866 18.8728)"
      >
        <Stop stopColor="#FFE0B9" />
        <Stop offset={1} stopColor="#DCAD70" />
      </RadialGradient>
      <RadialGradient
        id="paint1_radial_1051_8317"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.3601 21.6307) rotate(122.117) scale(24.8665 14.6077)"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="paint2_radial_1051_8317"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(30.51 36.66) rotate(143.62) scale(24.3179 26.2628)"
      >
        <Stop stopColor="#FFEED8" />
        <Stop offset={1} stopColor="#D59A4F" />
      </RadialGradient>
      <RadialGradient
        id="paint3_radial_1051_8317"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.2801 43.7449) rotate(115.907) scale(10.7653 7.8689)"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <ClipPath id="clip0_1051_8317">
        <Rect width={48} height={48} rx={8} fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default SVGComponent
